const buttons = document.querySelectorAll(".tabs .tab");
const sections = document.querySelectorAll(".tabs-content .content");

for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', function (){
        let target = event.target;
        let index = target.dataset.value;

        console.log('btn value',index)

        buttons.forEach( btn => {
            btn.classList.remove('active');
        })

        buttons[i].classList.add('active');

        sections.forEach( item => {
            let itemIndex = item.dataset.value;

            console.log('sections value',itemIndex)

            item.classList.remove('active');

            if ( itemIndex === index) {
                item.classList.add('active');
            }
        } )
    });
}